function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M553.785 364.599H148.174L123.988 89.4644H529.599L553.785 364.599Z",
  fill: "#D3E4FF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M141.018 373.368L148.175 364.599L123.99 89.4644L116.832 98.3678L141.018 373.368Z",
  fill: "#8CBBFF"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M153.548 354.165L131.255 100.718C131.027 98.0456 133.122 95.7493 135.808 95.7493H519.691C522.054 95.7493 524.028 97.5622 524.243 99.9123L546.522 353.359C546.75 356.031 544.655 358.328 541.97 358.328H158.087C155.723 358.328 153.749 356.515 153.548 354.165Z",
  fill: "#E6F0FF"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M205.194 364.599H144.078L139.754 376.967H200.87L205.194 364.599Z",
  fill: "#8CBBFF"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M205.191 364.599H607.016L602.691 376.967H200.867L205.191 364.599Z",
  fill: "#E6F0FF"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M370.651 364.599H447.68L446.848 372.697H369.832L370.651 364.599Z",
  fill: "#8CBBFF"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M502.614 134.922H599.934C608.005 188.316 570.699 232.242 517.319 232.242C500.237 232.242 482.779 227.743 466.691 219.202L502.614 134.922Z",
  fill: "#0056D2"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M502.617 134.922L553.916 60.3635C566.177 69.4953 576.665 80.91 584.615 93.7885C592.565 106.667 597.802 120.714 599.951 134.922H502.617Z",
  fill: "#4A91F7"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M502.615 134.922L487.91 37.6013C499.258 37.6013 510.834 39.5888 522.087 43.4698C533.341 47.3508 544.111 53.0716 553.914 60.3636L502.615 134.922Z",
  fill: "#73FFEA"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M502.616 134.922L466.693 219.202C433.994 201.839 410.546 169.649 405.309 134.922C397.238 81.5278 434.544 37.6013 487.925 37.6013L502.616 134.922Z",
  fill: "#CADFFF"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M373.085 298.802H409.613C412.305 298.802 413.88 295.898 412.322 293.795L310.634 155.485C310.014 154.633 309.005 154.128 307.925 154.128H271.396C268.705 154.128 267.129 157.032 268.687 159.136L370.376 297.446C370.978 298.298 372.005 298.802 373.085 298.802Z",
  fill: "#0056D2"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M309.049 299.252H268.785C266.536 299.252 265.208 296.748 266.518 294.94L317.283 225.063C317.938 224.159 319.018 223.603 320.151 223.603H358.663C361.496 223.603 363.161 226.698 361.532 228.958L311.298 298.104C310.785 298.835 309.952 299.252 309.049 299.252Z",
  fill: "#00E7C5"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M363.663 195.808C373.774 195.808 381.97 187.759 381.97 177.83C381.97 167.901 373.774 159.852 363.663 159.852C353.552 159.852 345.355 167.901 345.355 177.83C345.355 187.759 353.552 195.808 363.663 195.808Z",
  fill: "#00E7C5"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M223.913 222.52H102.944C95.2626 222.52 88.481 216.235 87.8498 208.567L81.7933 134.184C81.1621 126.502 86.9366 120.231 94.618 120.231H215.587C223.268 120.231 230.05 126.516 230.681 134.184L236.738 208.567C237.355 216.235 231.581 222.52 223.913 222.52Z",
  fill: "#E6F0FF"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M223.911 223.097H102.943C94.9523 223.097 87.9154 216.597 87.2708 208.607L81.2143 134.224C80.892 130.343 82.1275 126.676 84.679 123.91C87.2171 121.157 90.749 119.64 94.6165 119.64H215.585C223.576 119.64 230.613 126.139 231.257 134.13L237.314 208.513C237.636 212.394 236.401 216.06 233.849 218.827C231.297 221.58 227.779 223.097 223.911 223.097ZM94.6165 120.808C91.0713 120.808 87.8483 122.191 85.5385 124.702C83.2153 127.227 82.0872 130.584 82.3827 134.13L88.4392 208.513C89.0435 215.913 95.5566 221.942 102.956 221.942H223.925C227.47 221.942 230.693 220.559 233.003 218.048C235.326 215.523 236.454 212.166 236.159 208.621L230.102 134.237C229.498 126.838 222.985 120.808 215.585 120.808H94.6165Z",
  fill: "#407BFF"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M191.078 200.805C186.337 205.975 180.2 209.681 173.298 211.575L171.297 205.841C186.19 201.772 196.275 187.886 194.932 171.382C194.126 161.525 189.413 152.608 182.43 146.149L186.284 141.945C203.741 158.087 205.904 184.65 191.078 200.805Z",
  fill: "#00E7C5"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M186.284 141.945L182.429 146.149C175.446 139.689 166.207 135.701 156.35 135.701C146.493 135.701 137.899 139.703 131.99 146.162L127.438 141.945C134.609 134.143 144.842 129.752 155.867 129.752C166.905 129.752 177.85 134.143 186.284 141.945Z",
  fill: "#263238"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M173.299 211.575C159.266 215.416 143.581 211.293 132.22 200.805C114.775 184.663 112.613 158.1 127.425 141.945L131.978 146.162C126.042 152.621 122.779 161.525 123.585 171.382C125.183 191.069 142.453 207.036 162.153 207.036C165.336 207.036 168.411 206.62 171.285 205.841L173.299 211.575Z",
  fill: "#407BFF"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M59.1372 0H49.4414V1.16832H59.1372V0Z",
  fill: "#407BFF"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M40.0266 0H17.9492V1.16832H40.0266V0Z",
  fill: "#407BFF"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M142.735 106.895H21.78C14.0986 106.895 7.3169 100.611 6.68573 92.9425L0.629226 18.559C-0.00193924 10.8776 5.77256 4.6062 13.454 4.6062H134.423C142.104 4.6062 148.886 10.891 149.517 18.559L155.574 92.9425C156.191 100.624 150.417 106.895 142.735 106.895Z",
  fill: "#E6F0FF"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M142.734 107.486H21.7785C13.7882 107.486 6.75138 100.987 6.10679 92.9963L0.0502825 18.6128C-0.272015 14.7318 0.963461 11.0656 3.51498 8.29925C6.05307 5.54629 9.58492 4.02881 13.4525 4.02881H134.421C142.412 4.02881 149.449 10.5285 150.093 18.5188L156.15 92.9023C156.472 96.7833 155.236 100.449 152.685 103.216C150.133 105.969 146.602 107.486 142.734 107.486ZM13.4525 5.18371C9.90721 5.18371 6.68424 6.56689 4.37444 9.07813C2.05121 11.6028 0.923175 14.9466 1.21861 18.5053L7.27511 92.8889C7.87942 100.288 14.3925 106.318 21.7919 106.318H142.761C146.306 106.318 149.529 104.935 151.839 102.424C154.162 99.8988 155.29 96.5416 154.995 92.9963L148.938 18.6128C148.334 11.2134 141.821 5.18371 134.421 5.18371H13.4525Z",
  fill: "#407BFF"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5706 25.945H75.6675L75.1438 19.6199H11.0469L11.5706 25.945Z",
  fill: "#00E7C5"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M139.765 25.945H75.6683L75.1445 19.6199H139.255L139.765 25.945Z",
  fill: "#407BFF"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9144 42.4359H31.1913L30.681 36.0974H12.3906L12.9144 42.4359Z",
  fill: "#00E7C5"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M141.107 42.4359H31.19L30.6797 36.0974H140.597L141.107 42.4359Z",
  fill: "#407BFF"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M14.2581 58.9269H71.3047L70.7944 52.5884H13.7344L14.2581 58.9269Z",
  fill: "#00E7C5"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M142.446 58.9269H71.2994L70.7891 52.5884H141.936L142.446 58.9269Z",
  fill: "#407BFF"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5845 75.4042H112.972L112.448 69.0791H15.0742L15.5845 75.4042Z",
  fill: "#00E7C5"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M143.797 75.4042H112.977L112.453 69.0791H143.286L143.797 75.4042Z",
  fill: "#407BFF"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M16.9283 91.8949H61.9693L61.459 85.5564H16.418L16.9283 91.8949Z",
  fill: "#00E7C5"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M145.133 91.8949H61.9673L61.457 85.5564H144.61L145.133 91.8949Z",
  fill: "#407BFF"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M308.097 106.895H187.128C179.446 106.895 172.665 100.611 172.033 92.9425L165.977 18.559C165.346 10.8776 171.12 4.6062 178.802 4.6062H299.771C307.452 4.6062 314.234 10.891 314.865 18.559L320.921 92.9425C321.539 100.624 315.778 106.895 308.097 106.895Z",
  fill: "#E6F0FF"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M308.095 107.486H187.126C179.136 107.486 172.099 100.986 171.454 92.9961L165.398 18.6125C165.076 14.7315 166.311 11.0654 168.863 8.299C171.401 5.54605 174.933 4.02856 178.8 4.02856H299.769C307.759 4.02856 314.796 10.5282 315.441 18.5185L321.497 92.902C321.82 96.783 320.584 100.449 318.033 103.216C315.494 105.969 311.963 107.486 308.095 107.486ZM178.8 5.18346C175.255 5.18346 172.032 6.56665 169.722 9.07788C167.399 11.6025 166.271 14.9598 166.566 18.5051L172.623 92.8886C173.227 100.288 179.74 106.318 187.14 106.318H308.109C311.654 106.318 314.877 104.934 317.187 102.423C319.51 99.8986 320.638 96.5548 320.342 92.9961L314.286 18.6125C313.682 11.2131 307.168 5.18346 299.769 5.18346H178.8Z",
  fill: "#407BFF"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M247.466 91.8948H245.331L239.449 19.6196H241.584L247.466 91.8948Z",
  fill: "#E0E0E0"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M250.691 61.8541H237.222L234.926 33.6262H248.395L250.691 61.8541Z",
  fill: "#407BFF"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M220.96 91.8948H218.825L212.93 19.6196H215.065L220.96 91.8948Z",
  fill: "#E0E0E0"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M224.692 68.1252H211.21L209.195 43.3755H222.678L224.692 68.1252Z",
  fill: "#407BFF"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M194.435 91.8948H192.3L186.418 19.6196H188.553L194.435 91.8948Z",
  fill: "#E0E0E0"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M196.517 47.7671H183.047L181.664 30.7659H195.133L196.517 47.7671Z",
  fill: "#263238"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M273.974 91.8948H271.839L265.957 19.6196H268.092L273.974 91.8948Z",
  fill: "#E0E0E0"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M278.498 77.8884H265.029L261.43 33.6262H274.899L278.498 77.8884Z",
  fill: "#263238"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M300.499 91.8948H298.364L292.469 19.6196H294.604L300.499 91.8948Z",
  fill: "#E0E0E0"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M305.454 83.1927H291.985L289.098 47.74H302.567L305.454 83.1927Z",
  fill: "#407BFF"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M178.659 337.177H57.6901C50.0087 337.177 43.2271 330.892 42.5959 323.224L36.5394 248.84C35.9082 241.159 41.6827 234.887 49.3641 234.887H170.333C178.014 234.887 184.796 241.172 185.427 248.84L191.484 323.224C192.102 330.892 186.34 337.177 178.659 337.177Z",
  fill: "#F0F0F0"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M178.658 337.754H57.6887C49.6984 337.754 42.6615 331.254 42.0169 323.264L35.9604 248.881C35.6381 245 36.8736 241.333 39.4251 238.567C41.9632 235.814 45.4951 234.297 49.3626 234.297H170.332C178.322 234.297 185.359 240.796 186.003 248.787L192.06 323.17C192.382 327.051 191.147 330.717 188.595 333.484C186.057 336.25 182.525 337.754 178.658 337.754ZM49.3626 235.465C45.8174 235.465 42.5944 236.848 40.2846 239.359C37.9614 241.884 36.8333 245.241 37.1288 248.787L43.1853 323.17C43.7896 330.57 50.3027 336.599 57.7021 336.599H178.671C182.216 336.599 185.439 335.216 187.749 332.705C190.072 330.18 191.2 326.836 190.905 323.278L184.848 248.894C184.244 241.495 177.731 235.465 170.332 235.465H49.3626Z",
  fill: "#407BFF"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M65.7329 284.253L91.7987 314.374L121.705 268.259L140.184 292.095L144.696 285.139L174.925 321.357L58.8438 321.317L65.7329 284.253Z",
  fill: "#407BFF"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M152.769 286.133L140.656 312.078L102.007 250.707L83.8106 289.678L77.9689 280.426L58.8594 321.357L174.913 321.304L152.769 286.133Z",
  fill: "#0056D2"
});

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 608,
    height: 377,
    viewBox: "0 0 608 377",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.5f83e6e8.svg";
export { ForwardRef as ReactComponent };